import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { queries } from '../common/api/queryKeys/queries';
import { CompanyTabs } from '../company/common/CompanyTabs';
import { CustomerDetailPage } from '../company/customer/detail/CustomerDetailPage';

const customerCompanyDetailSearchSchema = z.object({
    tab: fallback(
        z.enum([CompanyTabs.DETAILS, CompanyTabs.SETTINGS, CompanyTabs.COMMUNICATION_PREFERENCES]),
        CompanyTabs.DETAILS
    ).default(CompanyTabs.DETAILS),
});

export const Route = createFileRoute('/_app/customer-groups/$groupId/companies/$companyId')({
    validateSearch: zodSearchValidator(customerCompanyDetailSearchSchema),
    async loader({ params, context }) {
        return Promise.all([
            context.queryClient.ensureQueryData({
                ...queries.customers.detail(params.companyId),
            }),
            context.queryClient.prefetchQuery({
                ...queries.customers.detail(params.companyId)._ctx.settings,
            }),
        ]);
    },
    component: CustomerDetailPage,
});
